'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcAnnotate
* @element SVG
* @description
* # tcAnnotate
* Allows SVG annotation
*/
angular.module('tcApp').directive('tcAnnotate', function($parse, $window, tcConstants, GlobalService, OverlayService) {
	return {
		restrict: 'A',
		scope: true,
		require: '^ngModel',
		link: function(scope, element, attrs, ngModel) {
			var dataItem = scope.data.items[attrs.tcAnnotate];
			if (angular.isUndefined(dataItem)) return;
			
			ngModel.$name = attrs.tcAnnotate;
			if ((scope.componentForm) && (scope.componentForm[scope.componentHtmlName])) {
				scope.componentForm[scope.componentHtmlName].$addControl(ngModel);
			}
			var mode = (attrs.tcAnnotateMode ? attrs.tcAnnotateMode : 'draw');
			var isTouchDevice = GlobalService.isTouchDevice();
			
			var svgNS = 'http://www.w3.org/2000/svg';
			var drawing = false;
			var currentPath = null;
			
			// Allows field to be activated on touch-screen devices
			var activate = function() {
				dataItem.isActivated = true;
				
				if ((mode === 'draw') && (!isDisabled())) {
					if (dataItem.defaultValue === '') clear();
					
					// Dismiss mobile keyboard
					if (isTouchDevice) scope.focusField();
					
					// Bind all applicable mouse & touch events
					if (!isTouchDevice) {
						element.on('mousedown', startDrawing);
						element.on('mousemove', continueDrawing);
						element.on('mouseup', stopDrawing);
					}
					// windows based devices / laptops with touchscreens but does not registers as document.ontouch
					// just add the touch events (the event.preventDefault() should counter both events triggering the other)
					element.on('touchstart', startDrawing);
					element.on('touchmove', continueDrawing);
					element.on('touchend', stopDrawing);
				}
			};
			
			var saveData = function() {
				// Possible issues with Mobile Safari -_-
				scope.data.items[attrs.tcAnnotate].value = element[0].innerHTML;
			};
			
			var getEventCoords = function(event) {
				var x = 0;
				var y = 0;
				
				if ((event.touches) && (event.touches.length)) {
					var elementPosition = element[0].getBoundingClientRect();
					x = (event.touches[0].pageX - elementPosition.left);
					y = (event.touches[0].pageY - elementPosition.top);
					
					// Take into account zoom level (CSS transform)
					// offsetWidth is not defined in Chrome/Android
					var elementWidth = (element[0].offsetWidth ? element[0].offsetWidth : element[0].clientWidth);
					if ((elementPosition.width) && (elementPosition.width !== elementWidth)) {
						x = ((elementWidth / elementPosition.width) * x);
					}
					var elementHeight = (element[0].offsetHeight ? element[0].offsetHeight : element[0].clientHeight);
					if ((elementPosition.height) && (elementPosition.height !== elementHeight)) {
						y = ((elementHeight / elementPosition.height) * y);
					}
				} else {
					x = event.offsetX;
					y = event.offsetY;
				}
				
				return {'x': x, 'y': y};
			};
			
			var startDrawing = function(event) {
				if (isDisabled()) return;
				if ((event.type === 'mousedown') && (event.which !== 1)) return;
				event.preventDefault();
				// skip drawing when image used as signature 
				if ((element[0].innerHTML.indexOf('svg') >= 0) || (element[0].innerHTML.indexOf('image') >= 0)) {
					return;
				}
				var coords = getEventCoords(event);
				currentPath = $window.document.createElementNS(svgNS, 'path');
				currentPath.setAttributeNS(null, 'd', 'M' + coords.x + ',' + coords.y + ' ');
				currentPath.setAttributeNS(null, 'stroke', tcConstants.COLOURS.BODY_FONT_COLOUR);
				currentPath.setAttributeNS(null, 'stroke-width', 2);
				element[0].appendChild(currentPath);
				
				drawing = true;
			};
			
			var continueDrawing = function(event) {
				if (isDisabled()) return;

				if (drawing) {
					// Prevent incorrect coordinates if event target changes while drawing (Firefox)
					if (event.target !== event.currentTarget) return;
					event.preventDefault();
					if (event.type === 'mousemove') {
						// In Firefox/IE, event.which does not give correct value for mousemove event
						if (((angular.isDefined(event.buttons)) && (event.buttons === 0)) || (event.which === 0)) {
							stopDrawing(event);
							return;
						}
					}
					if (currentPath) {
						var coords = getEventCoords(event);
						
						// Could be optimized
						var newPathSegment = 'L' + coords.x + ',' + coords.y + ' ';
						newPathSegment = newPathSegment + 'M' + coords.x + ',' + coords.y + ' ';
						currentPath.setAttributeNS(null, 'd', currentPath.getAttributeNS(null, 'd') + newPathSegment);
						
					}
				}
			};
			
			var stopDrawing = function(event) {
				if (!drawing) return;
				if (isDisabled()) return;
				if ((event.type === 'mouseup') && (event.which !== 1)) return;
				
				if (currentPath) currentPath = null;
				drawing = false;
				saveData();
				
				// Set the component item as 'dirty'
				if (dataItem.value !== dataItem.defaultValue) {
					ngModel.$setDirty();
					if (dataItem.required) ngModel.$setValidity('required', true);
				}
			};
	
			// Clear annotations
			var clear = function() {
				var childNodeLength = element[0].childNodes.length;
				for (var i = childNodeLength; i > 0; i--) {
					// Use this because childNodes[].remove() is not supported in IE11
					element[0].removeChild(element[0].childNodes[i - 1]);
				}
				scope.data.items[attrs.tcAnnotate].value = '';
				// When editing is enabled for existing data,
				// this will enable the blank container <SVG> element instead of the ng-include
				scope.data.items[attrs.tcAnnotate].defaultValue = '';
				currentPath = null;
				ngModel.$setDirty();
				if (dataItem.required) ngModel.$setValidity('required', false);
			};
			
			var isDisabled = function() {
				return (element[0].getAttribute('readonly') || element[0].getAttribute('disabled'));	
			};
			
			// Always activate for non-touch screen devices
			if (!isTouchDevice) activate();

			scope.$on('tcAnnotate:Activate', function($event, itemName) {
				if (itemName !== attrs.tcAnnotate) return;
				if (isDisabled() || dataItem.isActivated) return;
				activate();
			});

			scope.$on('tcAnnotate:Clear', function($event, itemName) {
				if (itemName !== attrs.tcAnnotate) return;
				if (isDisabled()) return;
				clear();
			});
			
			// open the overlay for signature pad interface
			scope.$on('tcAnnotate:openSignPadUrl', function($event, itemName, url, clickEvent) {
				if (itemName !== attrs.tcAnnotate) return;
				if (isDisabled()) return; 
				OverlayService.open({
					url: url + '&itemName=' + itemName,
					event: clickEvent,
					width: '600px',
					height: '300px'
				});
			});
			
			// update signature SVG html
			var updateSignSVGHtml = function(itemName, itemHtml) {  
				if (itemName !== attrs.tcAnnotate) return;
				if (isDisabled()) return; 
				clear();
				var signSVG = $window.document.createElementNS(svgNS, 'svg');
				signSVG.innerHTML = itemHtml;
				element[0].appendChild(signSVG);
				saveData();
			};
			
			//save signature data  
			scope.$on('tcAnnotate:UpdateData', function($event, itemName) {
				if (itemName !== attrs.tcAnnotate) return;
				if (isDisabled()) return;
				saveData();
			});
			
			// handle signature pad message
			var handleSignPadMessage = function(event) {
				if ($window.location.origin != event.origin) return;
				if (!angular.isObject(event.data)) return;
				if (event.data.target != 'tcAnnotate') {return;}
				if (event.data.itemName !== attrs.tcAnnotate) return;
				if (isDisabled()) return; 
				var itemName = event.data.itemName;
				var itemHtml = event.data.itemHtml;
				if (event.data.eventtype == 'tcAnnotate:clearSignItem') {
					clear();
				} else if (event.data.eventtype == 'tcAnnotate:closeSignOverlay') {
					OverlayService.close();
				} else if (event.data.eventtype == 'tcAnnotate:updateSignItem') {
					updateSignSVGHtml(itemName, itemHtml);
				}
				event.cancelBubble = true;
				event.stopImmediatePropagation();
			};
			
			// add listner to detect iframe messages for siganture pad 
			$window.addEventListener('message', handleSignPadMessage, false);
			
			// remove listner to avoid issues when questionnaire loaded multi times without reload 
			scope.$on('$destroy', function() {
					$window.removeEventListener('message', handleSignPadMessage, false);
				});
			
		}
	};
});
